import { makeStyles } from 'tss-react/mui';
import { selectClasses } from '@mui/material/Select';

export const useStyles = makeStyles()((theme) => ({
  header: {
    height: 'auto',
    padding: theme.spacing(3, 4),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#fff',
    maxHeight: 81,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 3),
    },
  },
  header__logo: {
    position: 'relative',
    width: 220,
    height: 31,
    [theme.breakpoints.down('sm')]: {
      width: 144,
      height: 'auto',
    },
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '& section.first': {
      fontSize: 18,
      lineHeight: 1.35,
      fontWeight: 600,
      display: 'block',
      position: 'relative',
      marginTop: -4,
    },
    '& ul': {
      marginLeft: '40px!important',
      listStyleType: 'none',
      margin: 0,
      '& li': {
        display: 'inline-block',
        margin: theme.spacing(0, 2.5),
      },
    },
    '& section.seccond': {
      fontSize: 14,
      fontWeight: 600,
      letterSpacing: 0.25,
      '& ul li': {
        margin: theme.spacing(0, 1.5),
      },
    },
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      paddingBottom: 2,
    },
    '& a.active': {
      color: theme.palette.primary.main,
      borderBottom: `3px solid ${theme.palette.error.main}`,
    },
    '& a:hover': { color: theme.palette.error.main },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  menuBtn: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.25,
    '& svg': {
      fontSize: 38,
      marginLeft: theme.spacing(2),
    },
  },
  drawer: {
    top: 82,
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      paddingBottom: 2,
    },
    '& a.active': {
      color: theme.palette.primary.main,
      borderBottom: `3px solid ${theme.palette.error.main}`,
    },
    '& a:hover': { color: theme.palette.error.main },
    '& section.first': {
      fontSize: 20,
      fontWeight: 600,
      display: 'block',
      position: 'relative',
      '& ul': {
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(0.25),
        textAlign: 'center',
        borderBottom: `2px solid ${theme.palette.divider}`,
        '& li': {
          display: 'inline-block',
          margin: '0 20px',
        },
      },
    },
    '& section.seccond': {
      fontSize: '1rem',
      fontWeight: 600,
      letterSpacing: 0.25,
      '& ul': {
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        paddingTop: theme.spacing(2),
        borderBottom: `2px solid ${theme.palette.divider}`,
        '& li': {
          margin: theme.spacing(2.5),
        },
      },
    },
  },
  languageSelectButton: {
    padding: 0,
    height: 24,
    '&:before': {
      borderBottom: 'none!important',
    },
    [`& .${selectClasses.select}`]: {
      padding: 0,
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: 0.25,
      color: theme.palette.error.main,
      backgroundColor: theme.palette.background.paper,
    },
    marginTop: -2,
  },
  logoutBtn: {
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.25,
    color: theme.palette.primary.main,
    textTransform: 'none',
    minWidth: 0,
    padding: theme.spacing(0, 1),
    '&:hover': {
      background: 'none',
      color: theme.palette.error.main,
    },
  },
}));
